import React from 'react';
import { useSiteConfig } from '../../context/SiteConfigContext';
import { useEditMode } from '../../context/EditModeContext';
import { useBuilder } from '../../context/BuilderContext';
import { useT } from '../../hooks/useT';
import { useSEO } from '../../hooks/useSEO';
import BlockWrapper from '../BlockWrapper/BlockWrapper';
import BlockInserter from '../BlockInserter/BlockInserter';
import styles from './PageRenderer.module.css';

function PageRenderer({ pageKey }) {
  const config = useSiteConfig();
  const { editMode } = useEditMode();
  const { deselectBlock } = useBuilder();
  const t = useT();
  const page = config.pages[pageKey];

  useSEO({
    title: t(page.seo.titleKey),
    description: t(page.seo.descriptionKey),
    ogImage: config.meta.ogImage,
    lang: config.meta.lang,
  });

  const blocks = page.blocks || [];
  const isEditing = editMode !== 'off';

  const handlePageClick = () => {
    if (isEditing) {
      deselectBlock();
    }
  };

  return (
    <section className={styles.page} onClick={handlePageClick}>
      {isEditing && <BlockInserter pageKey={pageKey} insertIndex={0} />}
      {blocks.map((block, index) => (
        <React.Fragment key={block.id}>
          <BlockWrapper
            block={block}
            pageKey={pageKey}
            blockIndex={index}
            totalBlocks={blocks.length}
          />
          {isEditing && <BlockInserter pageKey={pageKey} insertIndex={index + 1} />}
        </React.Fragment>
      ))}
    </section>
  );
}

export default PageRenderer;
